import { z } from "zod";
import {
  BASELINE_DATE,
  BILLING_AMOUNT,
  BILLING_CATEGORY,
  BILLING_DATE,
  BILLING_MONTH_YEAR,
  COMMENT,
  CURR_OWNER_ID,
  CURR_OWNER_NAME,
  DOCUMENT_ID,
  DOCUMENT_TYPE,
  DRCR,
  DUE_DATE,
  GL_ACCOUNT,
  INVOICE_DATE,
  LINE_BILLING_AMOUNT,
  LINE_ITEMS,
  PAYMENT_TERM,
  POSTING_DATE,
  PROPERTY,
  PROPERTY_BLOCK,
  PROPERTY_ID,
  PROPERTY_MODEL,
  STREET_ADDRESS,
  TRANSACTION_TYPE,
  UNIT_NO,
  PROPERTY_OWNERSHIP_ID,
  GL_MASTER_ID,
  BILLING_CATEGORY_ID,
  BUDGET_START_MONTH,
  BUDGET_END_MONTH,
  BUDGET_YEAR,
  JE_MASTER_ID,
  LINE_ITEM_TYPE,
  ITEM_TEXT
} from "./consts";

export const schema = z.object({
  [DOCUMENT_TYPE]: z.string().optional(),
  [DOCUMENT_ID]: z.string().optional(),
  [BILLING_MONTH_YEAR]: z.string().optional(),
  [BILLING_DATE]: z.string().optional(),
  [BILLING_AMOUNT]: z.string().optional(),
  [DUE_DATE]: z.any(),
  [TRANSACTION_TYPE]: z.string().optional(),
  [GL_ACCOUNT]: z.string().optional(),
  [PAYMENT_TERM]: z.string().optional(),
  [COMMENT]: z.string().optional(),
  [POSTING_DATE]: z.string().optional(),
  [BASELINE_DATE]: z.string().optional(),
  [INVOICE_DATE]: z.string().optional(),
  [JE_MASTER_ID]: z.string().optional(),
  // [POSTING_MONTH]: z.string().min(1, "This field is required"),
  // [YEAR]: z.string().min(1, "This field is required"),
  [LINE_ITEMS]: z
    .object({
      [BILLING_CATEGORY]: z.string().optional(),
      [PROPERTY_MODEL]: z.string().optional(),
      [PROPERTY_BLOCK]: z.string().optional(),
      [PROPERTY_ID]: z.string().optional(),
      [UNIT_NO]: z.string().optional(),
      [STREET_ADDRESS]: z.string().optional(),
      [CURR_OWNER_ID]: z.string().optional(),
      [CURR_OWNER_NAME]: z.string().optional(),
      [DRCR]: z.string().optional(),
      [LINE_BILLING_AMOUNT]: z.string().optional(),
      [PROPERTY_OWNERSHIP_ID]: z.string().optional(),
      [GL_MASTER_ID]: z.string().optional(),
      [BILLING_CATEGORY_ID]: z.string().optional(),
      [BUDGET_START_MONTH]: z.string().optional(),
      [BUDGET_END_MONTH]: z.string().optional(),
      [BUDGET_YEAR]: z.string().optional(),
      [LINE_ITEM_TYPE]: z.string().optional(),
      [ITEM_TEXT]: z.string().optional(),
      [PROPERTY]: z.any().optional()
    })
    .array(),
});

export type formValues = z.infer<typeof schema>;
